import { AxiosError } from 'axios';
import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  padding: ${({ theme }) => theme.spacing.md};
`;

const Title = styled.h3`
  background-color: ${({ theme }) => theme.colors.danger};
  color: ${({ theme }) => theme.colors.N0};
  padding: ${({ theme }) => theme.spacing.md};
`;

export function parseAxiosError(axiosError: AxiosError) {
  const { response } = axiosError;
  return {
    title: `${response?.status}: ${response?.statusText}`,
    message: `${response?.config?.method?.toUpperCase()}: ${
      response?.config.url
    }`,
  };
}

type ErrorContainerProps = PropsWithChildren<{
  title?: string;
  message?: string;
  details?: string;
}>;

function ErrorContainer({
  children,
  title,
  message,
  details,
  ...rest
}: ErrorContainerProps) {
  return (
    <Container {...rest}>
      {title && <Title>{title}</Title>}
      {message && <p>{message}</p>}
      {details && <code>{details.toString()}</code>}
      {children}
    </Container>
  );
}

export default ErrorContainer;
